import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box, InputLabel, Select,
  FormControl, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from 'react-router-dom';


import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';

const baseUrl=process.env.REACT_APP_API_BASE_URL
function PaidBusFeeList() {
  const {oId,role,userId,pId,board}=useAuth();
const { state } = useLocation();
const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [selectedBus, setSelectedBus] = useState("");
   const [selectedBusNoPlate, setSelectedBusNoPlate] = useState("");
  const [busData, setBusData] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dateRangeFromQuery = queryParams.get('dateRange');

   const [dialogOpen, setDialogOpen] = useState(false);
   const [selectedRowData, setSelectedRowData] = useState(null);
   const [selectedadmissionNo, setselectedAdmissionNo] = useState(null);

   const [dialogTableloading, setDialogTableloading] = useState(true);
   const [dialogTableData, setDialogTableData] = useState(null);

   //SSC states
     const [sscClassOptions, setSscClassOptions] = useState([]);
     const [sscSectionOptions, setSscSectionOptions] = useState([]);
     const [sscSelectedClass, setSscSelectedClass] = useState("");
     // const [sscSelectedSection, setSscSelectedSection] = useState("");
     const [sscSelectedSection, setSscSelectedSection] = useState("");
   
     // INTERMEDIATE states
     const [interSectionOptions, setInterSectionOptions] = useState([]);
     // const [interSelectedClass, setInterSelectedClass] = useState("");
     // const [interSelectedSection, setInterSelectedSection] = useState('');
     const [interSelectedClass, setInterSelectedClass] = useState("");
     const [interSelectedSection, setInterSelectedSection] = useState("");
     const [courseOptions, setCourseOptions] = useState([]);
     const [selectedCourseType, setSelectedCourseType] = useState("");
   
       const [tableLoading, setTableLoading] = useState(true);

     const [romanNumberClass, setRomanNumberClass] = useState("");
      const [dialogcourse, setDialogCourse] = useState("");
   
     const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
     console.log("selected mode :"+mode);
     const [sscClassSectionMap, setSscClassSectionMap] = useState({});
     const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag
   
     const [villageOptions, setVillageOptions] = useState([]);
       const [selectedVillage, setSelectedVillage] = useState("");

  

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
 
  

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  // const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const isPrincipal = role?.startsWith("PRINCIPAL") || role?.startsWith("ORGANIZATION") || false;
  // const UserId = selectedUsers;
  // console.log("Selected User:",UserId);

 const UserId = role === "ADMISSION_FEE" ? userId  : selectedUsers;



 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${PrincipalId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (role === "PRINCIPAL" || role === "TRANSPORT" || role === "ORGANIZATION") {
    fetchUsers();
  }
}, [role]); // ✅ Run when `role` is available or changes


   const [transportusers, settransportUsers] = useState([]);
  const [selectedTransportUsers, setSelectedTransportUsers] = useState('');

  
//     const fetchTransportUsers = async () => {
//         try {
//             const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${PrincipalId}`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch users');
//             }
//             const data = await response.json();
//             settransportUsers(data);
//             if (data.length > 0) {
//               setSelectedTransportUsers(data[0].userId); // ✅ Set first record's userId as default
//           }
//         } catch (error) {
//             console.error('Error fetching users:', error);
//         }
//     };

// useEffect(() => {
 
//     fetchTransportUsers();

// }, [oId,PrincipalId]); // ✅ Only runs on mount 






 const handleViewClick = (row) => {
   setSelectedRowData(row); // Set the selected row's data
   setselectedAdmissionNo(row.admissionNumber)
   setDialogOpen(true); // Open the dialog
 };

 const handleCloseDialog = () => {
   setDialogOpen(false); // Close the dialog
 };

//DIALOG TABLE DATA
 useEffect(() => {
  const fetchDialogTableData = async () => {
    if (!selectedadmissionNo) return; // Prevent API call if no admission number is selected

    setDialogTableloading(true);
    try {
      const response = await fetch(`${baseUrl}/api/transaction/getAllTransaction/${selectedadmissionNo}/${oId}/bus_fee`);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Fetched Data:", data);
      setDialogTableData(data || []); // Ensure it's always an array

    } catch (error) {
      console.error("Error fetching Bus Numbers:", error);
      setDialogTableData([]); // Ensure state remains consistent
    } finally {
      setDialogTableloading(false); // Set loading to false after fetching
    }
  };

  fetchDialogTableData();
}, [selectedadmissionNo, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes

//BUS NUMBERS DATA
  useEffect(() => {
    const fetchData = async () => {
      if (!PrincipalId) return;
      try {
        const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${PrincipalId}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setBusData(data || []); // Assuming 'data' is an array of bus numbers
        if (data.length > 0) {
          setSelectedBus(data[0].busNumber); // Set the first item as default
           setSelectedBusNoPlate(data[0].busNumberPlate); // store first object as default
          setSscSelectedClass();
        }
      } catch (error) {
        
        console.error("Error fetching Bus Numbers:", error);
      } 
    };

    fetchData();
  }, [PrincipalId]);


  //fetch students data with bus filter with class, section
  
  // -------------------------------------------
  //           For SSC functions
  // -------------------------------------------
  
  // ---- Fetch Class + Sections for SSC (School) ----
  const fetchClassRegistrationData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        // Group by class and merge section strings into unique values
        const classSectionMap = {};
  
        data.forEach(item => {
          const className = item.classRegistration;
          const sectionList = item.sections.split(",").map(s => s.trim());
  
          if (!classSectionMap[className]) {
            classSectionMap[className] = new Set();
          }
  
          sectionList.forEach(section => classSectionMap[className].add(section));
        });
  
        const classes = Object.keys(classSectionMap);
        setSscClassOptions(classes); // Class dropdown options
        setSscClassSectionMap(classSectionMap); // Save for section filtering later
  
        // No default selection
        setSscSelectedClass("");
        setSscSelectedSection("");
        setSscSectionOptions([]);
      }
    } catch (error) {
      console.error("Error fetching SSC data:", error);
    }
  };
  
  
  
  
  
  // ---- Fetch Table Data for SSC ----
  // const fetchClassSectionTableData = async () => {
  //   if (!sscSelectedClass || !sscSelectedSection) {
  //     setFilteredData([]);
  //     // setOriginalData([]);
  //     setTableLoading(false);
  //     return;
  //   }
  //   setTableLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/busFee/adm/getAllStudentTransactionsOnlyPaidWithClassAndSectionWise/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=bus_fee`
  //     );
  //     const data = await response.json();
  //     if (response.ok) {
  //       // setOriginalData(data);
  //       setFilteredData(data || []);
  //       // setFilteredData(data.feePayments || []);
  //       // setUniqueCourseType([...new Set(data.map(item => item.course))]);
  //     } else {
  //       // setOriginalData([]);
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching SSC table data:", error);
  //   } finally {
  //     setTableLoading(false);
  //   }
  // };
  
    const fetchClassSectionTableData = async () => {
    if (!sscSelectedClass || !sscSelectedSection) {
      setFilteredData([]);
      // setOriginalData([]);
      setTableLoading(false);
      return;
    }
    setTableLoading(true);
    try {

  let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    
    switch (dateRangeFromQuery) { // ✅ Changed to 'dateRange'
       case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getTodayBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getYesterDayBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastWeekBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentMonthBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastSixMonthsBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        break;
      case "currentAcademicYear":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
          break;
      // case "customDate":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getBusTransactionCustomClassAndSection/${startDate}/${endDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
      //   break;              
      
      default:
        // endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getTodayBusTransactionClassAndSectionWise/${formattedDate}/bus_fee/${oId}/${sscSelectedClass}/${sscSelectedSection}/${UserId}`;
        endpoint = `${baseUrl}/api/busFee/adm/getAllStudentTransactionsOnlyPaidWithClassAndSectionWise/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=bus_fee`;
        break;                
    }


      const response = await fetch(endpoint);            
      const data = await response.json();
      if (response.ok) {
        setFilteredData(data || []);
      } else {
        // setOriginalData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching SSC table data:", error);
    } finally {
      setTableLoading(false);
    }
  };
  
  
  // -------------------------------------------
  //           For Intermediate functions
  // -------------------------------------------
  
  // ---- Fetch Courses for INTERMEDIATE ----
  const fetchCourseData = async () => {
    if(!interSelectedClass) return;
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
      const data = await response.json();
      if (response.ok && Array.isArray(data)) {
        setCourseOptions(data);
        // if (!selectedCourseType) {
        //   setSelectedCourseType("");
        // }
      } else {
        setCourseOptions([]);
      }
    } catch (error) {
      console.error("Error fetching course data:", error);
      setCourseOptions([]);
    }
  };
  
  // ---- Fetch Sections for INTERMEDIATE ----
  
  const fetchSectionsData = async () => {
    if (!interSelectedClass || !selectedCourseType) {
      setInterSectionOptions([]);
      setInterSelectedSection("");
      return;
    }
  
    try {
      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
      );
      const data = await response.json();
  
      if (response.ok && Array.isArray(data) && data.length > 0) {
        const sectionsString = data[0].sections || "";
        const sections = sectionsString
          .split(",")
          .map((section) => section.trim());
  
        setInterSectionOptions(sections);
        setInterSelectedSection(sections[0] || "");
      } else {
        setInterSectionOptions([]);
        setInterSelectedSection("");
      }
    } catch (error) {
      console.error("Error fetching INTERMEDIATE section data:", error);
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  };
  
  
  
  
  
  
  // ---- Fetch Table Data for INTERMEDIATE ----
  const fetchCourseClassSectionTableData = async () => {
    if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
      setFilteredData([]);
      // setOriginalData([]);
      setTableLoading(false);
      return;
    }
    setTableLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=tution_fee`
        
      );
      const data = await response.json();
      if (response.ok) {
        // setOriginalData(data);
        setFilteredData(data.feePayments || []);
        // setUniqueCourseType([...new Set(data.map(item => item.course))]);
      } else {
        // setOriginalData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching INTERMEDIATE table data:", error);
      setFilteredData([]);
    } finally {
      setTableLoading(false);
    }
  };
  
  
  
  
  useEffect(() => {
    if (board === "INTERMEDIATE") {
      fetchSectionsData();
    } else if (board === "SSC") {
      fetchClassRegistrationData();
    }
  }, [board, interSelectedClass, selectedCourseType, oId]);
  
  // SSC: When selected class changes, update its sections
  // useEffect(() => {
  //   const updateSectionOptions = async () => {
  //     try {
  //       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
  //       const data = await response.json();
  //       if (response.ok && Array.isArray(data)) {
  //         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
  //         if (selectedClassData) {
  //           const sections = selectedClassData.sections.split(",");
  //           setSscSectionOptions(sections);
  //           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
  //         } else {
  //           setSscSectionOptions([]);
  //           setSscSelectedSection("");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error updating SSC sections:", error);
  //     }
  //   };
  
  //   if (board === "SSC" && sscSelectedClass) {
  //     updateSectionOptions();
  //   }
  // }, [sscSelectedClass, board, oId]);
  
  // INTERMEDIATE: When class or course type changes, update sections
  useEffect(() => {
    const updateIntermediateSections = async () => {
      if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
        await fetchSectionsData();
      }
    };
    updateIntermediateSections();
  }, [interSelectedClass, selectedCourseType, board]);
  
  
  
  // Fetch course options if board is INTERMEDIATE
  useEffect(() => {
    if (board === "INTERMEDIATE") {
      fetchCourseData();
    }
  }, [interSelectedClass,board, oId]);
  
  // Fetch Table Data whenever filters change
  // useEffect(() => {
  //   if (board === "SSC") {
  //     if (!sscSelectedClass || !sscSelectedSection) {
  //       setFilteredData([]);
  //       setTableLoading(false); // ✅ stop loading even if API not called
  //       return;
  //     }
  //     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  //   } else if (board === "INTERMEDIATE") {
  //     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
  //       setFilteredData([]);
  //       setTableLoading(false); // ✅ same here
  //       return;
  //     }
  //     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  //   }
  // }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);
  
  useEffect(() => {
    const fetchData = () => {
      if (board === "SSC") {
        if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
          fetchClassSectionTableData();
        } else {
          setFilteredData([]);
          setTableLoading(false);
        }
      } else if (board === "INTERMEDIATE") {
        if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
          fetchCourseClassSectionTableData();
        } else {
          setFilteredData([]);
          setTableLoading(false);
        }
      }
    };
  
    fetchData();
  }, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);
  

  //TABLE DATA FETCH API
    // const fetchBusFeeDetails = async () => {
    //   setLoading(true); // Set loading to true before fetching data
    //     try {
    //       const response = await fetch(
    //         `${baseUrl}/api/busFee/getAllStudentTransactionsOnlyPaid/${oId}?busNumber=${selectedBus}&rolePayment=bus_fee`
    //       );
  
    //       if (!response.ok) {
    //         throw new Error("Failed to fetch transactions");
    //       }
  
    //       const data = await response.json();
    //       // setFilteredData(data);
    //       setFilteredData(data || []); // Ensure it handles the correct response format
  
    //     } catch (err) {
    //       console.error("Error fetching transactions:", err);
    //     }finally {
    //       setLoading(false); // Set loading to false after fetching (whether success or error)
    //     }

    //   };
    // useEffect(() => {
    //   fetchBusFeeDetails();
    // }, [selectedBus]);



const fetchPaidBusFeesList = async () => {
  if (!UserId || !selectedBus) return;

  setLoading(true);

  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRangeFromQuery) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getTodayBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getYesterDayBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastWeekBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getThisMonthBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getLastSixMonthsBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      case "currentAcademicYear":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getCurrentAcademicYearBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}/${UserId}`;
        break;

      default:
        endpoint = `${baseUrl}/api/busFee/adm/getAllStudentTransactionsOnlyPaid/${oId}/${UserId}?busNumber=${selectedBus}&rolePayment=bus_fee`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();

    // Handle both response types
    const studentList = Array.isArray(data)
      ? data
      : data.studentBusList || [];

    setFilteredData(studentList);

    // Extract villages
    const villages = [
      ...new Set(
        studentList
          .map(item => item.studentPickupLocation)
          .filter(Boolean)
      )
    ];

    setVillageOptions(villages);

  } catch (error) {
    console.error("Error fetching bus fee data:", error);
    setFilteredData([]);
    setVillageOptions([]);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  fetchPaidBusFeesList();
}, [selectedBus,UserId]); 




    







 // Filter data based on searchQuery
//  const filteredResults = filteredData.filter((item) => {
//   const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
//   const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
//   const fullName = `${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
//   const admissionNumber = item.customAdmissionNumber ? item.customAdmissionNumber.toString() : ""; // Ensure it's a string

//   return (
//     fullName.includes(searchQuery.toLowerCase()) || // Search in full name
//     admissionNumber.includes(searchQuery) // Search in admission number
//   );
// });

const filteredResults = filteredData.filter((item) => {
  const studentFirstName = item.studentFirstName?.toLowerCase() || "";
  const studentLastName = item.studentLastName?.toLowerCase() || "";
  const fullName = `${studentFirstName} ${studentLastName}`;

  const matchesName = fullName.includes(searchQuery?.toLowerCase() || "");
  const matchesVillage = selectedVillage
    ? item.studentPickupLocation === selectedVillage
    : true;

  return matchesName && matchesVillage;
});




// Export to Excel
// const exportToExcel = () => {
//   const filteredData = filteredResults.map(({ 
//     customAdmissionNumber, studentFirstName, studentLastName, 
//     gender, busNumber, routeNumber, fatherPhoneNumber, 
//     grandTotal, totalPaid
//   }) => ({
//     AdmissionNumber: customAdmissionNumber,  
//     StudentName: `${studentFirstName} ${studentLastName}`,
//     Gender: gender,
//     BusNumber: busNumber,
//     Route: routeNumber,
//     Phone: fatherPhoneNumber,
//     TotalFee: grandTotal,
//     PaidAmount: totalPaid,
//   }));

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList`);

//   // Add headers
//   worksheet.columns = [
//     { header: "Admission No", key: "AdmissionNumber", width: 15 },
//     { header: "Student Name", key: "StudentName", width: 25 },
//     { header: "Gender", key: "Gender", width: 10 },
//     { header: "Bus No", key: "BusNumber", width: 10 },
//     { header: "Route", key: "Route", width: 10 },
//     { header: "Phone", key: "Phone", width: 15 },
//     { header: "Total Fee", key: "TotalFee", width: 15 },
//     { header: "Paid Amount", key: "PaidAmount", width: 15 },
//   ];

//   // Add data rows and style the "Paid Amount" column in green
//   filteredData.forEach((data) => {
//     const row = worksheet.addRow(data);
//     const paidAmountCell = row.getCell("PaidAmount");

//     // Apply green text color to the "Paid Amount" column
//     paidAmountCell.font = { color: { argb: "008000" }, bold: true }; // Green and bold
//   });

//   // Style headers
//   worksheet.getRow(1).eachCell((cell) => {
//     cell.font = { bold: true };
//     cell.alignment = { horizontal: "center" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "87CEEB" }, // Light blue header
//     };
//   });

//   // Write and download file
//   workbook.xlsx.writeBuffer().then((buffer) => {
//     const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = `${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList.xlsx`;
//     link.click();
//   });

//   handleExportClose();
// };

const exportToExcel = () => {
  const filteredData = filteredResults.map(
    ({
      customAdmissionNumber,
      romanNumberClass,
          sections,
          course,
      studentFirstName,
      studentLastName,
      gender,
      busNumber,
      busNumberPlate,
      routeNumber,
      studentPickupLocation,
      grandTotal,
      totalPaid,
    }) => ({
      AdmissionNumber: customAdmissionNumber,
       Course: course,
          Class: romanNumberClass,
          Section: sections,
      StudentName: `${studentFirstName} ${studentLastName}`,
      Gender: gender || "NA",
      BusNumber: busNumberPlate || "NA",
      Route: routeNumber || "NA",
      Phone: studentPickupLocation || "NA",
      TotalFee: grandTotal || 0,
      PaidAmount: totalPaid || 0,
    })
  );

  const workbook = new ExcelJS.Workbook();
  // const worksheetName = `${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''
  //   }-${selectedBus}_PaidBusFeeList`;
  // const worksheet = workbook.addWorksheet(worksheetName);

  const worksheet = workbook.addWorksheet(
            (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
              ? `${interSelectedClass}-${interSelectedSection}_PaidBusFeeList`
              : (board === "SSC" && sscSelectedClass && sscSelectedSection)
                ? `${sscSelectedClass}-${sscSelectedSection}_PaidBusFeeList`
                : `${selectedBusNoPlate}_PaidBusFeeList`
          );

  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    ...(board === "INTERMEDIATE"
          ? [{ header: "Course", key: "Course", width: 15 }]
          : []),
        { header: board === "INTERMEDIATE" ? "Year" : "Class", key: "Class", width: 15 },
        { header: "Section", key: "Section", width: 15 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Bus No", key: "BusNumber", width: 20 },
    { header: "Route", key: "Route", width: 10 },
    { header: "Village Name", key: "Phone", width: 15 },
    { header: "Total Fee", key: "TotalFee", width: 15 },
    { header: "Paid Amount", key: "PaidAmount", width: 15 },
  ];

  // Add student rows with conditional formatting
  filteredData.forEach((data) => {
    const row = worksheet.addRow(data);
    const paidCell = row.getCell("PaidAmount");
    paidCell.font = { color: { argb: "008000" }, bold: true }; // Green
  });

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light blue
    };
  });

  // Totals calculation
  const totalFeeSum = filteredData.reduce((sum, item) => sum + (item.TotalFee || 0), 0);
  const totalPaidSum = filteredData.reduce((sum, item) => sum + (item.PaidAmount || 0), 0);

  worksheet.addRow({}); // Blank row

  const totalRow = worksheet.addRow({
    AdmissionNumber: "Total Amount",
    TotalFee: `₹${totalFeeSum.toLocaleString("en-IN")}`,
    PaidAmount: `₹${totalPaidSum.toLocaleString("en-IN")}`,
  });

  // Style total row
  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF9C4" }, // Light Yellow
    };
  });

  // Merge A to F for "Total Amount" label
  worksheet.mergeCells(`A${totalRow.number}:H${totalRow.number}`);

  // Export the Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);

    // link.download = `${worksheetName}.xlsx`;

    link.download =
  board === "INTERMEDIATE" && interSelectedClass && interSelectedSection
    ? `${interSelectedClass}-${interSelectedSection}_PaidBusFeeList.xlsx`
    : board === "SSC" && sscSelectedClass && sscSelectedSection
    ? `${sscSelectedClass}-${sscSelectedSection}_PaidBusFeeList.xlsx`
    : `${selectedBusNoPlate}_PaidBusFeeList.xlsx`;
    
    link.click();
  });

  handleExportClose();
};

// Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}${selectedBusNoPlate}_Paid Bus Fee List`, 10, 8);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 10, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 35, 16);

  // Table
  doc.autoTable({
    startY: 20,
    head: [["S.No", "Admission No", "Student Name", "Gender", "Bus No", "Route", "Village Name", "Total Amount", "Paid Amount"]],
    body: filteredResults.map((row, index) => [
      index + 1,
      row.customAdmissionNumber,
      `${row.studentFirstName} ${row.studentLastName}`,
      row.gender||"N/A",
      row.busNumberPlate,
      row.routeNumber,
      row.studentPickupLocation,
      row.grandTotal,
      { content: row.totalPaid, styles: { textColor: [0, 128, 0], fontStyle: "bold" } }, // Green color for Paid Amount
    ]),
     margin: { top: 0, left: 3, right: 3 },
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  doc.save(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}${selectedBusNoPlate}_Paid BusFeeList.pdf`);
  handleExportClose();
};


// Export to JSON
const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredResults, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList.json`;
  link.click();
  handleExportClose();
};

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent
        // style={{
        //   maxWidth: "950px",
        //   margin: "auto",
        // }}
      >
        {/* Title Section */}
        {/* <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Paid Bus Details
            </Typography>
          </Grid>
          
        </Grid> */}
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              {`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''} Paid Bus Fee Details`}
                              </Typography>
                            </Box>

     {/* Search and Add New Button Section */}
<Grid
  container
  spacing={2}
  alignItems="center"
  wrap="nowrap"
  style={{
    marginTop: "8px",
    overflowX: "auto",
    flexWrap: "nowrap",
  }}
>
  {/* All Filters */}
  <Grid
    item
    xs
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
      whiteSpace: "nowrap",
    }}
  >
    {/* Search Field */}
    <TextField
      label="Search by Admission No or Name"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{ width: "200px" }}
    />

    {/* Select Bus */}
    <FormControl sx={{ width: 180 }} size="small">
      <InputLabel id="bus-select-label">Select Bus</InputLabel>
      <Select
        labelId="bus-select-label"
        value={selectedBus}
        // onChange={(e) => setSelectedBus(e.target.value)}
 onChange={(e) => {
  // setSelectedBus(e.target.value);
   const value = e.target.value;
      setSelectedBus(value);
  // ✅ find bus object by busNumber
      const selected = busData.find((b) => b.busNumber === value);
      if (selected) {
        setSelectedBusNoPlate(selected.busNumberPlate || selectedBusNoPlate);
      }
      setSelectedVillage("");
  setSscSelectedClass("");
  setSscSelectedSection("")
}}
        label="Select Bus"
      >
        {busData.map((bus, index) => (
         <MenuItem key={index} value={bus.busNumber}>
               {bus.busNumberPlate}
             </MenuItem>
        ))}
      </Select>
    </FormControl>

     {/*select village*/}
                    <FormControl style={{ width: "150px" }} variant="outlined" size="small">
          <InputLabel id="village-select-label" style={{ fontSize: "12px" }}>
            Select Village
          </InputLabel>
          <Select
            labelId="village-select-label"
            value={selectedVillage}
            onChange={(e) => setSelectedVillage(e.target.value)}
            label="Select Village"
            style={{ height: "35px", fontSize: "13px" }}
          >
            <MenuItem value="">
              <em>All Villages</em>
            </MenuItem>
        
            {villageOptions.map((village, index) => (
              <MenuItem key={index} value={village}>
                {village}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

    {/* SSC Filters */}
    {board === "SSC" && (
      <>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="class-select-label">Select Class</InputLabel>
          <Select
            labelId="class-select-label"
            value={sscSelectedClass}
            onChange={(e) => {
              const selected = e.target.value;
              setSscSelectedClass(selected);
              setMode("classSection");
              setSelectedBus("");
               setSelectedVillage("");
              const sections = sscClassSectionMap[selected]
                ? Array.from(sscClassSectionMap[selected])
                : [];
              setSscSectionOptions(sections);
              setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
            }}
            label="Select Class"
            sx={{ height: 35 }}
          >
            {sscClassOptions.map((cls) => (
              <MenuItem key={cls} value={cls}>
                {cls}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="section-select-label">Select Section</InputLabel>
          <Select
            labelId="section-select-label"
            value={sscSelectedSection}
            onChange={(e) => {
              setSscSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {sscSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Class
              </MenuItem>
            ) : (
              sscSectionOptions.map((section) => (
                <MenuItem key={section} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}

    {/* INTERMEDIATE Filters */}
    {board === "INTERMEDIATE" && (
      <>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
          <Select
            labelId="intermediate-class-select-label"
            value={interSelectedClass}
            onChange={(e) => setInterSelectedClass(e.target.value)}
            label="Select Year"
            sx={{ height: 35 }}
          >
            <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
            <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="course-type-label">Select Course</InputLabel>
          <Select
            labelId="course-type-label"
            value={selectedCourseType}
            onChange={(e) => {
              setSelectedCourseType(e.target.value);
              setMode("classSection");
            }}
            label="Select Course"
            sx={{ height: 35 }}
          >
            {courseOptions.map((course, index) => (
              <MenuItem key={index} value={course}>
                {course}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
          <Select
            labelId="intermediate-section-select-label"
            value={interSelectedSection || ""}
            onChange={(e) => {
              setInterSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {interSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Year and Course
              </MenuItem>
            ) : (
              interSectionOptions.map((section, index) => (
                <MenuItem key={index} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}
  </Grid>

  {/* Export Button */}
  <Grid item xs="auto">
    <Button
      variant="contained"
      onClick={handleExportClick}
      style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
      startIcon={<PresentToAllIcon />}
    >
      Export
    </Button>

    <Menu
      anchorEl={exportAnchorEl}
      open={isExportMenuOpen}
      onClose={handleExportClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        },
      }}
    >
      <MenuItem
        onClick={exportToExcel}
        sx={{
          color: "#3f51b5",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#e8f0fe",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#00796b" }}>
          <SimCardDownloadIcon />
        </ListItemIcon>
        <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
      </MenuItem>

      <MenuItem
        onClick={exportToPDF}
        sx={{
          color: "#d32f2f",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#fdecea",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#d32f2f" }}>
          <PictureAsPdfIcon />
        </ListItemIcon>
        <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
      </MenuItem>
    </Menu>
  </Grid>
</Grid>



<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Admission No
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  {board === "INTERMEDIATE" ? "Year" : "Class"}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Section
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Gender
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Bus No
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Route
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Pickup
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Drop
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Village Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Paid Amount
                </TableCell>
                 <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Payment Details </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                   <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                      <CircularProgress />
                                                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                                                        Loading Data...
                                                                      </Typography>
                                                                    </Box>
                                                                  </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow key={row.id} style={{
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    height: "40px",  // Reduced row height
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white"; // Default color
                  }}>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                      
                    >
                      {index + 1}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Avatar
                          src={row.photo}
                          alt={row.name}
                          sx={{ width: 30, height: 30, marginRight: 1 }}
                        />
                        <Typography variant="body2" color="textSecondary">
                          {row.id}
                        </Typography>
                      </Box>
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.customAdmissionNumber}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.paymentDate}
                    </TableCell>
                       {board === "INTERMEDIATE" && (
                       <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.course}
                    </TableCell>
                       )}

                     <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.romanNumberClass}
                    </TableCell>
                     <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.sections}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentFirstName} {row.studentLastName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.gender || "N/A"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busNumberPlate}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.routeNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentPickupLocation}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentDropLocation}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentPickupLocation}
                    </TableCell>
                    <TableCell
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
   
  }}
>
  <Button
    style={{
      backgroundColor: "#65C63E",
      color: "#fff",
      fontWeight: "bold",
      textTransform: "none",
      borderRadius: "20px",
    }}
  >
    ₹{row.totalPaid}
  </Button>
</TableCell>
<TableCell
              sx={{
                borderLeft: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              <Button
                type="button"
                onClick={() => handleViewClick(row)} // Open dialog with the row data
                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  fontSize: "0.6rem", // Reduces the font size
                  height: "25px", // Reduces the height
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                }}
              >
                View
              </Button>
            </TableCell>

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="sm" sx={{ borderRadius: 3 }}>
  <DialogTitle 
    sx={{ 
      fontWeight: "bold", 
      textAlign: "center", 
      bgcolor: "#1976d2", 
      color: "white",
      py: 2,
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3
    }}
  >
    Paid Bus Fee Payment Details
  </DialogTitle>
  <DialogContent>
    {selectedRowData && (
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "column",
          marginTop:"20px" ,
          gap: 2, 
          p: "20px 20px 20px 20px",
          bgcolor: "#f5f5f5", 
          borderRadius: 2 
        }}
      >
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Student Name: 
          <span style={{ fontWeight: "normal", color: "#2e7d32" , fontWeight: "bold"}}>{selectedRowData.studentFirstName} {selectedRowData.studentLastName}</span>
        </Typography>
       
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Total Amount: 
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>₹{selectedRowData.grandTotal}</span>
        </Typography>
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
        {`${
              dateRangeFromQuery
                ? dateRangeFromQuery.charAt(0).toUpperCase() +
                  dateRangeFromQuery.slice(1)
                : ""
            } Paid Amount:`}
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>₹{selectedRowData.totalPaid}</span>
        </Typography>
        {/* <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Status: 
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>Bus Fee Cleared</span>
        </Typography> */}

 {/* Transactions Toggle Section */}
 <Box 
              sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                cursor: "pointer",
                fontWeight: "bold",
                color: "#1976d2",
                "&:hover": { textDecoration: "underline" }
              }} 
              onClick={() => setShowTransactions(!showTransactions)}
            >
              <Typography variant="h6"> Show Transactions</Typography>
              <Typography variant="h6">{showTransactions ? "▲" : "▼"}</Typography>
            </Box>

            {/* Transaction Table - Conditional Rendering */}
            {showTransactions && (
              <TableContainer component={Paper} sx={{ mt: 2, maxHeight: "100px", overflowY: "auto",}} className="custom-sidebar-scrollbar">
                <Table stickyHeader>
                  <TableHead sx={{ bgcolor: "#1976d2" }} >
                    <TableRow>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Sl No</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Payment Date</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Amount Paid</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Transaction ID</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Payment Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {dialogTableloading ? (
                <TableRow>
                   <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                      <CircularProgress />
                                                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                                                        Loading Data...
                                                                      </Typography>
                                                                    </Box>
                                                                  </TableCell>
                </TableRow>
              ) : dialogTableData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                dialogTableData.map((transaction, index) => (
                      <TableRow key={transaction.transactionId}>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{index + 1}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.paymentDate}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>₹{transaction.paymentAmount}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.transactionId || "N/A"}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.payMethod}</TableCell>
                      </TableRow>
                    ))
                  )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
    )}
  </DialogContent>
  <DialogActions sx={{ justifyContent: "flex-end", pt: 0.5,pb: 1, pr: 2 }}>
  <Button 
    onClick={handleCloseDialog} 
    variant="contained" 
    sx={{ 
      fontSize: "0.8rem", // Slightly smaller font size
      // px: 3, 
      // py: 0.5, // Reduced height
      // borderRadius: 2, 
      bgcolor: "#3C3972", // Elegant blue color
      color: "white",
      "&:hover": { bgcolor: "#3C3972" } 
    }}
  >
    Close
  </Button>
</DialogActions>

</Dialog>
      </CardContent>
    </Card>
  );
}

export default PaidBusFeeList;